import { render, staticRenderFns } from "./DanLink.vue?vue&type=template&id=0f925b04&"
import script from "./DanLink.vue?vue&type=script&lang=js&"
export * from "./DanLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports